// Logo de marca: icono (imagen) + wordmark en texto para que se adapte al tema.
// `tone="light"` fuerza texto blanco (para fondos oscuros fijos como el footer).
export const BRAND_NAVY = '#0B2545';
export const BRAND_TEAL = '#0BB5A6';

export default function BrandLogo({ size = 36, showText = true, showTagline = false, tone = 'auto', style }) {
  const textColor = tone === 'light' ? '#fff' : tone === 'dark' ? BRAND_NAVY : 'var(--text)';
  const fontSize = Math.round(size * 0.58);
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: Math.round(size * 0.28), ...style }}>
      <img src="/brand/logo-mark.png" alt={showText ? '' : 'MedCover Pro'} width={size} height={Math.round(size * 1.14)} style={{ height: Math.round(size * 1.14), width: 'auto', flexShrink: 0 }} />
      {showText && (
        <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
          <span style={{ fontSize: Math.max(8, Math.round(size * 0.22)), fontWeight: 700, letterSpacing: 2, color: tone === 'light' ? 'rgba(255,255,255,0.75)' : 'var(--blue)', marginBottom: 2 }}>TH</span>
          <span style={{ fontSize, fontWeight: 800, letterSpacing: -0.5, color: textColor, whiteSpace: 'nowrap' }}>
            MedCover<span style={{ color: BRAND_TEAL, fontWeight: 700 }}>Pro</span>
          </span>
          {showTagline && (
            <span style={{ fontSize: Math.max(8, Math.round(size * 0.2)), fontWeight: 600, letterSpacing: 2.4, textTransform: 'uppercase', color: tone === 'light' ? 'rgba(255,255,255,0.7)' : 'var(--text-muted)', marginTop: 4, whiteSpace: 'nowrap' }}>
              Gestión de cobertura sanitaria
            </span>
          )}
        </span>
      )}
    </span>
  );
}
